import { Action, Dispatch } from "redux";
import { SiteSetting, OpeningHours } from "../models/settings.model";
import { UpdatePageAction, UPDATE_PAGE } from "./page.actions";
import fetchSiteSettings from "../helpers/fetchSiteSettings";
import fetchOpeningHours from "layout/Footer/blocks/Footer1/helpers/fetchOpeningHours";

export const GET_SITE_SETTINGS = "GET_SITE_SETTINGS";
export const GET_OPENING_HOURS = "GET_OPENING_HOURS";

export interface GetSiteSettingsAction extends Action {
    type: typeof GET_SITE_SETTINGS;
    content: SiteSetting;
}

export interface GetOpeningHoursAction extends Action {
    type: typeof GET_OPENING_HOURS;
    openingHours: OpeningHours;
}

let siteSettingsCache: Promise<any> | undefined = undefined;
export const thunkGetSiteSettings =
    (url: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        try {
            if (!url) {
                throw new Error();
            }

            // Check for cached site settings.
            const request = typeof siteSettingsCache !== "undefined" ? siteSettingsCache : fetchSiteSettings(url);
            siteSettingsCache = request;

            const response = await request;

            if (response && response._contentType === "siteSettings") {
                const siteSetting: SiteSetting = response;
                if (siteSetting?.venueId) {
                    try {
                        const openingHoursResult = await fetchOpeningHours(siteSetting.venueId);
                        if (openingHoursResult.status === 200) {
                            const actionOpeningHours: GetOpeningHoursAction = {
                                type: GET_OPENING_HOURS,
                                openingHours: openingHoursResult,
                            };
                            dispatch(actionOpeningHours);
                        }
                    } catch (e: any) {
                        console.error("Error while fetching opening hours", e);
                    }
                }

                const action: GetSiteSettingsAction = {
                    type: GET_SITE_SETTINGS,
                    content: response,
                };

                dispatch(action);
            }
        } catch {
            const action: UpdatePageAction = {
                type: UPDATE_PAGE,
                content: {
                    _contentType: "errorPage",
                    _name: "An error occured",
                    _url: url,
                },
                statusCode: 500,
            };

            dispatch(action);
        }
    };

export type SiteSettingsAction = GetSiteSettingsAction | GetOpeningHoursAction;
